<template>
  <div class="edit_frame">
    <common_edit></common_edit>
    <div class="title mb-12">样式</div>
    <my_opacity :value.sync="module.style.opacity" title="透明度"></my_opacity>
    <my_radius :value.sync="module.style['border-radius']" title="圆角" v-if="module.imgType!='qrCode'"></my_radius>
  </div>
</template>

<script type="text/javascript">
import common_edit from '../../module_edit/common_edit.vue'
import my_opacity from '../../my_opacity'
import my_radius from '../../my_radius'
export default {
  name: 'BasicImageEdit',
  data() {
    return {
      fitOptions: [
        { label: '打开', value: 'fill' },
        { label: '关闭', value: 'cover' }
      ],
      activeCollapseItem: 0,
      myActiveValue: 'fill',
      myInactiveValue: 'cover',
      isBorderRadius: false,
      isShadowX: false,
      isShadowY: false,
      isShadowBlur: false,
      showBorderSet: false,
      showShadowSet: false,
      isBorderWidth: false
    }
  },
  props: {},
  methods: {
    outsideBorderWidth() {
      this.isBorderWidth = false
    },
    outsideBorderRadius() {
      this.isBorderRadius = false
    },
    outsideShadowBlur() {
      this.isShadowBlur = false
    },
    outsideShadowY() {
      this.isShadowY = false
    },
    outsideShadowX() {
      this.isShadowX = false
    }
  },
  computed: {
    boderWasSet() {
      // 判断之前是否设置过boder
      if (this.module.style['border-color'] !== '' || this.module.style['border-width'] !== 0 || this.module.style['border-style'] !== 'solid' || this.module.style['border-radius'] !== 0) {
        return true
      }
      return false
    },
    shadowWasSet() {
      // 判断之前是否设置过boder
      if (this.module.shadow.x !== 0 || this.module.shadow.y !== 0 || this.module.shadow.blur !== 0) {
        return true
      }
      return false
    },
    module() {
      const module = this.$store.state.widgets.module_Data
      if (!module.fit) {
        this.$set(module, 'fit', 'cover')
      }
      return module
    }
  },
  watch: {
    'showBorderSet': {
      handler(val) {
        if (val) {
          // 如果boder设置过就不需要初始
          if (!this.boderWasSet) {
            this.module.style['border-style'] = 'solid'
            this.module.style['border-color'] = 'rgba(0,0,0,1)'
            this.module.style['border-width'] = 2
          }
        } else {
          this.module.style['border-style'] = 'solid'
          this.module.style['border-color'] = ''
          this.module.style['border-width'] = 0
          this.module.style['border-radius'] = 0
        }
      }
    },
    'showShadowSet': {
      handler(val) {
        if (val) {
          // 如果阴影设置过就不需要初始
          if (!this.shadowWasSet) {
            this.module.shadow.x = 10
            this.module.shadow.y = 10
          }
        } else {
          this.module.shadow.x = 0
          this.module.shadow.y = 0
          this.module.shadow.blur = 0
        }
      }
    }
  },
  created() {},
  mounted() {
    console.log('this.module.style', this.module.style)
    // 如果设置过boder就需要让边框设置显示
    this.showBorderSet = this.boderWasSet
    // this.showShadowSet = this.shadowWasSet
  },
  components: {
    common_edit,
    my_opacity,
    my_radius
  }
}
</script>

<style lang="scss" scoped>
.edit_frame {
  padding-top: 15px;
  .title{
        font-size: 14px;
        color: #1D2129;
        font-weight: 500;
        line-height: 40px;
    }
  .section-top {
    padding: 0 16px;
    .item_switch {
      align-items: center;
      margin-bottom: 15px;
      border-bottom: 1px solid #f5f5f5;
      .title {
        color: #333;
        font-size: 13px;
        font-weight: 500;
        // margin-bottom: 11px;
      }
      .el-switch {
        width: 44px;
        height: 36px;
        line-height: 36px;
      }
      ::v-deep .el-switch__core {
        background-color: #b9bcc8;
      }
    }
    .item_color {
      padding-bottom: 12px;
      margin-bottom: 15px;
      border-bottom: 1px solid #f5f5f5;
      ::v-deep {
        .my_edit_item {
          margin-bottom: 0;
        }
        .click_bottom .bottom {
          top: 25px;
        }
        .el-checkbox {
          margin-bottom: 11px;
          .el-checkbox__inner {
            border-color: #BBBECA;
          }
          .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
            background-color: #0086FF;
            border-color: #0086FF;
          }
          .el-checkbox__input.is-checked+.el-checkbox__label {
            color: #0086FF;
          }
        }
      }
    }
    .item-wrapper {
      padding-bottom: 12px;
      margin-bottom: 15px;
      border-bottom: 1px solid #f5f5f5;
      .item-title {
        color: #333;
        font-size: 13px;
        font-weight: 500;
        margin-bottom: 11px;
      }
      ::v-deep {
        .edit_item_inline .title {
          display: block;
        }
        .my_edit_item {
          margin-bottom: 0;
        }
        .el-checkbox {
          margin-bottom: 11px;
          .el-checkbox__inner {
            border-color: #BBBECA;
          }
          .el-checkbox__input.is-checked+.el-checkbox__label {
            color: #0086FF;
          }
          .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
            background-color: #0086FF;
            border-color: #0086FF;
          }
        }
      }
    }
    ::v-deep {
      .normal-color-wrapper {
        margin-right: 8px;
        .title {
          display: block;
        }
      }
      .el-input--medium .el-input__inner,
      .my-num-symbol {
        height: 24px;
        line-height: 24px;
      }
      .el-input-number--medium {
        line-height: 24px;
      }
    }
  }
  .el-collapse {
    border-top: 0;
    border-bottom: 0;
    padding: 0 16px;
    ::v-deep {
      .input-wrapper {
          height: 24px;
          .my-num-symbol {
            top: 0;
            height: 24px;
            line-height: 24px;
          }
          .el-input-number--medium,
          .el-input-number--small {
            line-height: 23px;
          }
          .el-input--medium .el-input__inner,
          .el-input--small .el-input__inner {
            height: 24px;
            line-height: 24px;
          }
          &:hover {
            .my-num-symbol {
              display: block !important;
            }
            .el-input-number__increase,
            .el-input-number__decrease {
              display: none;
            }
          }
        }
        .my_slider_layer {
          .el-slider .el-slider__button {
            width: 14px;
            height: 14px;
          }
        }
    }
  }
  .flexbox {
    ::v-deep .el-input-number.is-controls-right .el-input__inner {
      padding-right: 30px;
    }
  }
  .sel_powerover{
  position: relative;
  .sel_box {
    position: absolute;
    width: 100%;
    top: 28px;
    left: 0px;
    z-index: 1;
  }
}
  ::v-deep .set_two_level {
    justify-content: space-between;
  }
  .bottom {
    margin-bottom: 12px;
  }
  .bottom_small {
    // margin-bottom: 10px;
    ::v-deep {
      .edit_item_inline {
        margin-bottom: 7px;
      }
      .input-wrapper {
        height: 24px;
        .my-num-symbol {
          top: 0;
          height: 24px;
          line-height: 24px;
        }
        .el-input-number--medium {
          line-height: 23px;
        }
        .el-input--medium .el-input__inner {
          height: 24px;
          line-height: 24px;
        }
        &:hover {
          .my-num-symbol {
            display: block !important;
          }
          .el-input-number__increase,
          .el-input-number__decrease {
            display: none;
          }
        }
      }
    }
  }
}
.item-title {
  font-size: 14px;
  margin-bottom: 5px;
}

.my_edit_item {
  flex: 1;
}
</style>
